import React, { useState } from 'react';
import Pagination from '../../../common/Pagination'


const CommentsTab = ({ patientComments, onPageChange, getStatusBadge, formatDate }) => {
    const [currentPage, setCurrentPage] = useState(0);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        onPageChange(page);
    };
    console.log("Patient Comments Tab:",patientComments)
    return (
        <div className="card border-0 shadow-sm">
            <div className="card-header bg-transparent border-0">
                <h5 className="card-title mb-0">
                    <i className="bi bi-chat-dots text-info me-2"></i>
                    Patient Comments
                    <span className="badge bg-primary ms-2 text-white">{patientComments?.totalElements}</span>
                </h5>
            </div>
            <div className="card-body">
                {patientComments?.content?.length > 0 ? (
                    <>
                        <div className="row g-3">
                            {patientComments.content.map((comment) => (
                                <div key={comment.id} className="col-12">
                                    <div className="card border">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar bg-primary text-white rounded-circle p-2 me-3">
                                                        {comment.firstName.charAt(0)}{comment.lastName.charAt(0)}
                                                    </div>
                                                    <div>
                                                        <h6 className="mb-0">{comment.firstName} {comment.lastName}</h6>
                                                        <small className="text-muted">Patient ID: {comment.patientId.slice(0, 8)}...</small>
                                                    </div>
                                                </div>
                                                {getStatusBadge(comment.status)}
                                            </div>
                                            <p className="text-muted mb-3">{comment.notes}</p>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <small className="text-muted">
                                                    <i className="bi bi-clock me-1"></i>
                                                    {formatDate(comment.createdAt)}
                                                </small>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <Pagination
                            currentPage={currentPage}
                            totalPages={patientComments.totalPages}
                            onPageChange={handlePageChange}
                            totalElements={patientComments.totalElements}
                            pageSize={patientComments.pageable?.pageSize || 10}
                        />
                    </>
                ) : (
                    <div className="text-center py-5">
                        <i className="bi bi-chat-dots display-1 text-muted"></i>
                        <h5 className="text-muted mt-3">No patient comments</h5>
                        <p className="text-muted">Patient comments will appear here once they are submitted</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CommentsTab;